import React, { useEffect, useState } from 'react';
import { Modal } from '@els/els-react--modal';
import { LinkElement } from '@els/els-react--link-element';
import { Icon } from '@els/els-react--icon';
import { Button } from '@els/els-react--button';
import Bowser from 'bowser';

import './OutdatedBrowserModal.scss';

export default function OutdatedBrowserModal() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const browser = Bowser.getParser(window.navigator.userAgent);
  const browserName = browser.getBrowserName();
  const browserVersion = browser.getBrowserVersion();
  const isSupported = browser.satisfies({
    firefox: '>=49',
    chrome: '>=53',
    edge: '>=14',
    ie: '>=11',
    safari: '>=9',
  });
  const LEARN_MORE_LINK = 'https://service.elsevier.com/app/answers/detail/a_id/11644/kw/browser/supporthub/reaxys/';

  useEffect(() => {
    if (!isSupported) {
      setIsModalOpen(true);
    }
  }, [isSupported]);

  return (
    <div>
      {isModalOpen && (
        <Modal id="outdated-browser-modal" className="outdated-browser-modal" shouldHideCloseButton onClose={() => setIsModalOpen(false)}>
          <div>
            <h3 className="u-els-margin-bottom-1x">
              <Icon className="u-els-margin-right-1o2" sprite="InformationSolidSquare" color="secondary" size="m" isDecorative />
              Unsupported Browser
            </h3>
            <p>Reaxys has detected that you are using an unsupported or untested browser.</p>
            <LinkElement
              href={LEARN_MORE_LINK}
              id="icon-outdated-modal"
              a11y={{ name: 'Learn more about browsers we support' }}
              isExternal
              iconSprite="ChevronRight"
              iconSize="xs"
              iconRight
              iconEmphasis>
              Learn more
            </LinkElement>
            <p className="u-els-margin-top-1x">
              You may continue using Reaxys, but please be aware that you may experience performance and functionality limitations when
              using this browser.
            </p>
            <p className="u-els-margin-top-1x">
              Your browser: {browserName} {browserVersion}
            </p>
            <div className="u-els-margin-top-1x u-els-float-right">
              <Button onClick={() => setIsModalOpen(false)}>I understand</Button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}
